import { render, staticRenderFns } from "./panel-list.vue?vue&type=template&id=91217538&"
import script from "./panel-list.vue?vue&type=script&lang=js&"
export * from "./panel-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports